module.exports = __webpack_public_path__ + "img/n6.16d9cb7f.svg";